import BackButton from '@components/BackButton'
import ProfileClock from '@components/ProfileClock'
import Select from '@components/Select'
import { useRouter } from 'next/router'
import React, { useContext, useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { CrossInstrcutorContext, FMIStudentProfileContext, useFave } from '../../context'
import { Back, ClockWrapper, Selector, SelectWrapper, Wrapper } from './style'
import { useFMIBulkForm } from '../../BulkForm/Form/useFMIBulkForm'
import { H1 } from '@berlitz/globals'

export interface GenericOption {
  label: string
  value: string
}

export interface IPageHeader {
  options: GenericOption[]
  onChange: (_value: string) => void
  defaultValue: string
  loading?: boolean
  disabled?: boolean
  notSaved?: boolean | string
  setToURL?: (data: string) => void
  setOpenModal?: (data: boolean) => void
  instructorId?: string
}

const noop = () => {}

export const PageHeader: React.FC<IPageHeader> = ({
  options,
  onChange,
  defaultValue,
  loading,
  disabled,
  notSaved,
  setToURL = noop,
  setOpenModal = noop,
  instructorId,
}) => {
  const { state } = useContext(CrossInstrcutorContext)
  const { userProfile, isAdmin } = useContext(FMIStudentProfileContext)
  const { isBulkOnlyFeature, selectedInstructors = [] } = useFMIBulkForm()
  const { rawInstructors = [] } = useFave()
  const router = useRouter()
  const [value, setValue] = useState(defaultValue)
  const [instructorName, setInstructorName] = useState('')

  const checkValue = (val: string) => {
    if (notSaved && !state.allowed) {
      setOpenModal(true)
      setToURL(`id:${val}`)
    } else {
      setValue(val)
      onChange(val)
    }
  }

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  useEffect(() => {
    if (isBulkOnlyFeature && (rawInstructors.length || selectedInstructors.length)) {
      setInstructorName(
        [...rawInstructors, ...selectedInstructors]?.find(({ InstructorId: Id }) => Id === instructorId)?.Name || ''
      )
    }
  }, [isBulkOnlyFeature, rawInstructors, selectedInstructors, instructorId])

  return (
    <>
      <Wrapper>
        <Selector>
          {isBulkOnlyFeature ? (
            <SelectWrapper>
              {loading ? (
                <Skeleton height="46px" style={{ maxWidth: '300px', minWidth: '215px' }} />
              ) : (
                <H1 disableMargin>{instructorName}</H1>
              )}
            </SelectWrapper>
          ) : (
            <SelectWrapper>
              {loading ? (
                <Skeleton height="46px" style={{ maxWidth: '300px', minWidth: '215px' }} />
              ) : (
                <Select
                  onChange={checkValue}
                  options={options}
                  disableMargin
                  value={value}
                  responsive
                  disabled={disabled}
                />
              )}
            </SelectWrapper>
          )}
          <Back>
            {loading ? (
              <Skeleton width="69px" height="28px" />
            ) : (
              <BackButton
                onClick={() => {
                  if (notSaved) {
                    setToURL('back')
                    setOpenModal(true)
                  } else {
                    router.back()
                  }
                }}
              />
            )}
          </Back>
        </Selector>
        <ClockWrapper>
          {loading ? (
            <Skeleton width="100%" height="32px" style={{ minWidth: '215px' }} />
          ) : isAdmin ? (
            <ProfileClock timezone={userProfile?.Timezone} hideChangeLink={isAdmin} />
          ) : (
            <ProfileClock />
          )}
        </ClockWrapper>
      </Wrapper>
    </>
  )
}

export default PageHeader
